import React, { useState, useEffect } from 'react';
import './App.css';
import Header from './components/header';
import Home from './pages/home';
import PopUp from './components/popUp';
import Footer from './components/footer';

function App() {
  const [isPopupOpen, setPopupOpen] = useState(false);

  const openPopup = () => {
    setPopupOpen(true);
  };

  const closePopup = () => {
    setPopupOpen(false);
  };

  useEffect(() => {
    const handleScroll = () => {
      const elements = document.querySelectorAll('.fade-out, .fade-out-right');

      elements.forEach((el) => {
        if (isElementInView(el)) {
          if (el.classList.contains('fade-out')) {
            el.classList.remove('fade-out');
            el.classList.add('fade-in');
          } else if (el.classList.contains('fade-out-right')) {
            el.classList.remove('fade-out-right');
            el.classList.add('fade-in-right');
          }
        } else {
          if (el.classList.contains('fade-out')) {
            el.classList.add('fade-out');
            el.classList.remove('fade-in');
          } else if (el.classList.contains('fade-out-right')) {
            el.classList.add('fade-out-right');
            el.classList.remove('fade-in-right');
          }
        }
      });
    };

    const isElementInView = (el) => {
      const rect = el.getBoundingClientRect();
      return (
        rect.top >= 0 &&
        rect.left >= 0 &&
        rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
        rect.right <= (window.innerWidth || document.documentElement.clientWidth)
      );
    };

    window.addEventListener('scroll', handleScroll);
    window.addEventListener('load', handleScroll);

    handleScroll();

    return () => {
      window.removeEventListener('scroll', handleScroll);
      window.removeEventListener('load', handleScroll);
    };
  }, []);

  return (
    <div className="App">
      <Header />
      <Home openPopup={openPopup} />
      <PopUp isOpen={isPopupOpen} onClose={closePopup} />
      <Footer />
    </div>
  );
}

export default App;
